import { w as withConfigTransport } from "../../services/config-transport/withConfigTransport-31ef3979.mjs";
import { _ as _VaContent } from "./VaContent-c3c95e0e.mjs";
const VaContent = withConfigTransport(_VaContent);
export {
  VaContent as V
};
//# sourceMappingURL=index-34c579c8.mjs.map
